"use client";

import Link from "next/link";
import { HiHome } from "react-icons/hi";
import { FormattedMessage } from "react-intl";
import { useLocale } from "@/app/providers/IntlProvider";
import { homePath } from "@/lib/locale-routing";

const NotFoundPage = () => {
  const { locale } = useLocale();
  return (
    <main className="min-h-dvh w-full bg-surface p-4 flex">
      <div className="min-h-full w-full flex flex-col items-center gap-4 justify-center bg-slate-100 rounded-xl z-20 text-center px-4 text-slate-800">
        <h1 className="text-xl md:text-4xl lg:text-5xl font-bold italic text-sec-blue">
          <FormattedMessage id="notFound.error" />{" "}
          <span
            className="text-2xl md:text-5xl lg:text-6xl"
            style={{
              background: "linear-gradient(90deg, #F6A2FE, #A140E1)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            404
          </span>
        </h1>
        <p className="text-2xl text-slate-500">
          <FormattedMessage id="notFound.message" />
        </p>
        <Link
          href={homePath(locale)}
          className="flex min-h-11 items-center justify-center mx-auto bg-surface gap-2 px-4 py-2 rounded-lg group hover:bg-slate-600 transition-colors duration-300"
        >
          <HiHome aria-hidden="true" className="text-2xl group-hover:text-white transition-colors duration-300" />
          <span className="font-bold group-hover:text-white transition-colors duration-300">
            <FormattedMessage id="notFound.home" />
          </span>
        </Link>
      </div>
    </main>
  );
};

export default NotFoundPage;
